import { makeStyles } from '@material-ui/core/styles';
import { Checkup } from 'api/generated';
import { FC } from 'react';
import { DeleteButton, SaveButton, Toolbar, ToolbarProps } from 'react-admin';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const CheckupsToolbar: FC<ToolbarProps> = (props) => {
  const checkupRecord = props.record as Checkup;
  const checkup = checkupRecord.name || checkupRecord.id;
  return (
    <Toolbar {...props} classes={useStyles()}>
      <SaveButton label="Save" disabled={props.pristine} />
      <DeleteButton
        confirmTitle="Checkup remove"
        confirmContent={`Are you sure you want to delete item "${checkup}"?`}
        label="Remove"
        mutationMode="optimistic"
      />
    </Toolbar>
  );
};
